module.exports = __webpack_public_path__ + "img/ffp_agent_delivery_schedule.1a9410b0.jpg";